import { z } from "zod";
export const CallScriptItemSchema = z.object({
    id: z.string(),
    text: z.string(),
    notes: z.string().optional(),
});
export const CallScriptSectionSchema = z.object({
    id: z.string(),
    title: z.string(),
    items: z.array(CallScriptItemSchema),
});
export const CallScriptSchema = z.object({
    id: z.string(),
    orgId: z.string().optional(),
    title: z.string(),
    sections: z.array(CallScriptSectionSchema).optional(),
    schemaVersion: z.number().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
